import { loggedinAccount as typeLoggedinAccount } from '../types';
import deepCopy from '../../../util/deepCopy';
import merge from 'deepmerge';

const initialState = {
    loggedinAccount: {
        id: null,
        name: null,
        identification: null
    }
};
const state = deepCopy(initialState);

const getters = {
    [typeLoggedinAccount.getters.get]: state => {
        return state.loggedinAccount === initialState ? null : state.loggedinAccount;
    }
};

const mutations = {
    [typeLoggedinAccount.mutations.set]: (state, newAccount) => {
        state.loggedinAccount = merge(state.loggedinAccount, newAccount);
    },
    [typeLoggedinAccount.mutations.reset]: (state) => {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    }
};

const actions = {
    [typeLoggedinAccount.actions.set]: (context, newAccount) => {
        context.commit(typeLoggedinAccount.mutations.set, newAccount);
    },
    [typeLoggedinAccount.actions.reset]: (context) => {
        context.commit(typeLoggedinAccount.mutations.reset);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
